/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_No_DataInputs */

const vi_irrigation_devices_no_data = /** @type {(inputs: Irrigation_Devices_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có dữ liệu`)
};

/**

* @param {Irrigation_Devices_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_no_data = /** @type {((inputs?: Irrigation_Devices_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_no_data(inputs)
});